export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     *  Preloader Script
     */
     $(document).ready(function() {
    // $(document).on('load', function()  {
      // alert('Страница загружена');
      document.body.classList.add('loaded_hiding');
      window.setTimeout(function () {
        document.body.classList.add('loaded');
        document.body.classList.remove('loaded_hiding');
      }, 3000);
    });

    /**
     *  Folowing Scroll
     */
    $('.flowing-scroll').on( 'click', function(event){ 
      event.preventDefault();
      let el = $(this);
      let dest = el.data("flowingscroll");
      if(dest !== undefined && dest !== '') {
          $('html').animate({
            scrollTop: $(dest).offset().top
          }, 1000
          );
      }
      return false;
    });

    /**
     *  Folowing Scroll
     */
     $( document ).ready(function() {
      $('.header-button').on('click', function() {
          $(this).toggleClass('header-button-active');
          $('.language-nav').toggleClass('language-nav-active');
          $('.header-menu').toggleClass('header-menu-active');
      });
      $('.menu-item-has-children a').on('click', function(event) {
          if($(this).parent().hasClass('menu-item-has-children')) {
              event.preventDefault();
              $(this).parent().toggleClass('menu-item-has-children-active');
              $(this).parent().children('.sub-menu').toggleClass('sub-menu-active');
          }
      });
  
      // Scroll Top
      $(window).scroll(function() {
          var height = $(window).scrollTop();
  
          $('.header-button-active').removeClass('header-button-active');
          $('.language-nav-active').removeClass('language-nav-active');
          $('.header-menu-active').removeClass('header-menu-active');
  
          if(height > 300){
              $('.button-up-block').addClass('d-block');
          } else{
              $('.button-up-block').removeClass('d-block');
          }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
